import * as orderTypeEnum from '~/enums/order-type'

export const isBuyOrder = (orderType) => {
  return orderType === orderTypeEnum.values.Buy
}

export const isSellOrder = (orderType) => {
  return orderType === orderTypeEnum.values.Sell
}
